import { Injectable, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { IMasterValue } from 'src/app/core/models/api/master';
import { MasterDataService } from '../shared/masterData.service';
import { EditProjectContract } from './edit-project.contract';

@Injectable({ providedIn: 'root' })
export class EditProjectService implements EditProjectContract {
  private master = inject(MasterDataService);

  checkCondition(model: any): boolean {
    const e = model?.edit;
    if (!e) { return true; }

    const anySelected
      = !!e.projectIndustryLife
      || !!e.projectIndustryAccident
      || !!e.projectIndustryTemporaryIncapacity
      || !!e.projectIndustryDependency
      || !!e.projectIndustryWholeLife
      || !!e.projectIndustryDeath;

    return !anySelected;
  }

  checkClient(model: any): boolean {
    const form: FormGroup | undefined = model?.edit?.form;
    if (!form) { return true; }
    form.markAllAsTouched();
    return form.invalid;
  }

  getPaymentTypes(): Observable<IMasterValue[]> {
    return this.master.getPaymentTypes();
  }

  getActivities(): Observable<IMasterValue[]> {
    return this.master.getActivities();
  }

  getSports(): Observable<IMasterValue[]> {
    return this.master.getSports();
  }

  getLivingStandards(): Observable<IMasterValue[]> {
    return this.master.getLivingStandards();
  }

  getChildren(): Observable<IMasterValue[]> {
    return this.master.getChildren();
  }

  getContributionsGeneralReg(): Observable<IMasterValue[]> {
    return this.master.getContributionsGeneralReg();
  }

  getContributionsRETA(): Observable<IMasterValue[]> {
    return this.master.getContributionsRETA();
  }

  getMutualIncomes(): Observable<IMasterValue[]> {
    return this.master.getMutualIncomes();
  }

  getDeadlinesIPT(): Observable<IMasterValue[]> {
    return this.master.getDeadlinesIPT();
  }

  getMaritalStatuses(): Observable<IMasterValue[]> {
    return this.master.getMaritalStatuses();
  }

  getMotorbikes(): Observable<IMasterValue[]> {
    return this.master.getMotorbikes();
  }
}
